import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { useRouter } from "./hooks/router";

import Auth from './components/Auth/Auth'
import LayoutSubUsers from "./components/SubUsers/LayoutSubUsers";
import LayOutHome from "./components/LayOutHome/LayOutHome";
import LayoutLive from "./live_components/LayOutLive/LayoutLive";
import { login_guest_mode } from "./server/requests";

import "./App.css";
import "./full_screen.scss"

import {
    get_language,
    set_online,
    translated_words,
    get_configs,
    get_not_read_messages_count,
    validate_token,
    get_user_by_id,
    autoSignInSubUser
} from "./server/requests";

import { hex_to_rgb, translateWord, info_device, generate_id, crypt, decrypt } from "./components/Util/util";
import CustomStyle from "./style/CustomStyle";


import Loading from "./components/Loading/Loading";

window.translated_word_list = {}

function App() {

    const token = decrypt('token', localStorage.getItem("token"))
    const router = useRouter()

    const [network, setNetwork] = useState(false)
    const [type, setType] = useState('live')

    const [appColors, setAppColors] = useState('')
    const [configs, setConfigs] = useState('')
    const [appSettings, setAppSettings] = useState('')

    const [showAllComponents, setShowAllComponents] = useState(false)
    const [isGuest, setIsGuest] = useState(false)

    useEffect(() => {

        window.ononline = () => { setNetwork(false) }

        window.onoffline = () => { setNetwork(true) }

    }, [network])

    useEffect(() => {

        if (!localStorage.getItem('disable_code')) {
            localStorage.setItem('disable_code', 'true')
        }

        setOnline()
        get_translated_words()

    }, []);

    const get_translated_words = () => {

        let active_lang = JSON.parse(localStorage.getItem('language'))

        if (active_lang && active_lang != 'null') {
            get_words(active_lang.id)
            req_get_configs(active_lang.id)

        } else {

            get_language({}, res => {

                let active_language = res.find(e => e.default == true)

                req_get_configs(active_language.id)

            })

        }

    }

    const req_get_configs = (id) => {

        get_configs({ languageId: id }, res => {

            localStorage.setItem('logo', res.basics[0].start_logo)
            document.querySelector('link').href = res.basics[0].start_logo
            document.title = res.basics[0].app_name

            if (!res.app_settings.enable_payment) res.app_settings.enable_payment = false

            if (!localStorage.getItem('language')) localStorage.setItem('language', JSON.stringify(res.basics[0].language))

            if (res.basics[0].background_image) localStorage.setItem('background_image', res.basics[0].background_image)

            setConfigs(res.basics[0])

            if (res.app_settings) setAppSettings(res.app_settings)

            if (res.app_settings && res.app_settings.only_web_tv) setType('live')
            else setType('web')

            if (res.app_settings && res.app_settings.sub_users_disabled) localStorage.setItem('sub_users_disabled', true)

            else localStorage.removeItem('sub_users_disabled')

            if (res.skin) {

                if (res.app_settings && res.app_settings.only_web_tv) setType('live')

                else setType('web')

                let keys = Object.keys(res.skin)
                let app_colors = {}

                app_colors.gradient_bg = `rgba(${hex_to_rgb(res.skin.bg)},.8) !important`

                for (let i = 0; i < keys.length; i++) {

                    if (keys[i] == 'poster_gradient_web') {
                        app_colors[keys[i]] = res.skin[keys[i]]

                        continue
                    }

                    let _color = `rgb(${hex_to_rgb(res.skin[keys[i]])}) !important`

                    app_colors[keys[i]] = _color

                }
                setAppColors({ ...app_colors })
                localStorage.setItem('theme', JSON.stringify(app_colors))
            }

            get_words(id, res.app_settings)

        }, err => {
            console.log(err, 'err configs')
        })

    }

    const get_words = (id, app_settings) => {

        const body = {
            id: id
        }

        translated_words(body, res => {

            let arr_words = {}

            for (let i = 0; i < res.length; i++) {

                let _key = res[i].key.toLowerCase()

                arr_words[_key] = res[i].translatedWord

            }

            window.translated_word_list = JSON.parse(JSON.stringify(arr_words))

            if (!localStorage.getItem('token') && typeof app_settings.is_authorization_enabled == 'boolean') {

                if (app_settings.is_authorization_enabled) {
                    setIsGuest(false)
                    app_load(app_settings)
                }

                else {
                    login_guest()
                    setIsGuest(true)
                }

            } else {

                if (app_settings.is_authorization_enabled) {
                    setIsGuest(false)
                    app_load(app_settings)
                } else {
                    if (localStorage.getItem('token')) {
                        validate_token({ token: decrypt('token', localStorage.getItem("token")) }, res => {

                            if (res.is_guest) {
                                setIsGuest(true)
                                router.push('/')
                            } else {
                                setIsGuest(false)
                            }

                            setShowAllComponents(true)
                            router.push('/')

                        }, err => {
                            setIsGuest(true)
                            setShowAllComponents(true)
                            router.push('/')
                        })
                    }

                }
            }

        }, err => console.log(err, 'errr tranlate'))

    }

    const app_load = (app_settings) => {

        if (router.query && router.query.token && router.query.root_user_id && router.query.device_id && router.query.a == 'messages') {
            localStorage.clear()

            is_valid(router.query.token)
            return
        }

        if (token) {

            if (!sessionStorage.getItem('ok')) {

                sessionStorage.setItem('ok', 'ok')

                if (!localStorage.getItem('user')) {
                    autoSignInSubUser(router)
                }

            }

        } else {

            if (router.pathname.indexOf('/auth') == -1) router.push('/auth')

        }

        setShowAllComponents(true)

    }

    const login_guest = () => {
        let result

        if (localStorage.getItem('device_id')) result = localStorage.getItem('device_id')
        else {
            result = generate_id()
            localStorage.setItem('device_id', result)
        }

        let device_info = info_device()

        var body = {
            device_id: result,
            device_model: device_info.split(' ')[0],
            device_name: device_info.split(' ')[1]
        }

        login_guest_mode(body, res => {

            var obj_sub = {
                age_restricted: 21,
                audio_language: "",
                createdAt: Date.now(),
                id: Date.now(),
                image: "",
                isLiveWatching: false,
                is_protected: false,
                is_quiz_passed: true,
                last_online: Date.now(),
                level: 0,
                name: "Guest",
                online: true,
                password: "",
                progress: 0,
                root: true,
                subtitle_language: "",
                updatedAt: "2023-02-18T09:18:23.000Z",
                userId: -1,
                watchingChannelId: null
            }

            localStorage.setItem('token', crypt('token', res))
            localStorage.setItem('user', crypt('user', JSON.stringify(obj_sub)))
            setShowAllComponents(true)
            router.push('/')

        }, err => {
            console.log(err)
        })

    }

    const is_valid = (_token) => {

        validate_token({ token: _token }, res => {

            if (res.is_guest) {
                login_guest()
            } else {
                localStorage.setItem('token', crypt('token', router.query.token))

                if (router.query.root_user_id) {

                    localStorage.setItem('device_id', router.query.device_id)
                    localStorage.setItem('token', crypt('token', router.query.token))

                    get_sub_user_by_id(router.query.token)

                } else {

                    autoSignInSubUser(router)

                }
            }

        }, err => {
            router.push('/auth')
        })

    }

    const get_sub_user_by_id = (_token) => {

        get_user_by_id({}, res => {

            localStorage.setItem('user', crypt('user', JSON.stringify(res)))
            setShowAllComponents(true)

            router.push('/settings?a=messages')

        }, err => {

            router.push('/auth')

        })

    }

    const setOnline = () => {

        let _channel_id;
        let _isLive
        let _time = 0;

        setInterval(function () {

            var str = window.location.href;
            var objURL = {};

            // local isArray - defer to underscore, as we are already using the lib
            var isArray = []

            str.replace(
                new RegExp("([^?=&]+)(=([^&]*))?", "g"),
                function ($0, $1, $2, $3) {

                    if (objURL[$1] && !isArray(objURL[$1])) {

                        // if there parameter occurs more than once, convert to an array on 2nd
                        var first = objURL[$1]

                        objURL[$1] = [first, $3]

                    } else if (objURL[$1] && isArray(objURL[$1])) {

                        // if there parameter occurs more than once, add to array after 2nd
                        objURL[$1].push($3)

                    } else {

                        // this is the first instance
                        objURL[$1] = $3;

                    }

                }
            );
            if (objURL.type == 'live' && objURL.id) {
                _channel_id = objURL.id
                _isLive = 1
            } else {
                _isLive = 0
                _channel_id = 0
            }

            var body = {
                isLive: _isLive,
                channelId: _channel_id,
                // sub_userId: subId,
            }

            if (_time % 15 == 0 && _time != 0) request_set_online(body)

            _time++

        }, 1000);

    }

    const request_set_online = (body) => {
        set_online(body, res => { }, err => { })
    }

    return (
        showAllComponents ? <>
            {network ?
                <div className="errorConnection">
                    <h2>{translateWord('Error')}</h2>
                    <h1>{translateWord('Your device may not connected to the Internet.Please make sure your connection is working.')}</h1>
                </div>
                : null}

            <>
                {network ?
                    <div className="errorConnection">
                        <h2>{translateWord('Error')}</h2>
                        <h1>{translateWord('Your device may not connected to the Internet.Please make sure your connection is working.')}</h1>
                    </div>
                    : null}
                {
                    type == 'live' ?
                        <Switch>
                            <Route path={'/auth'}>
                                <Auth configs={configs} isGuest={isGuest} setIsGuest={setIsGuest} />
                            </Route>
                            <Route path={'/subusers'}>
                                <LayoutSubUsers isGuest={isGuest} appSettings={appSettings} />
                            </Route>
                            <Route path={'/'}>
                                <LayoutLive configs={configs} network={network} type={type} isGuest={isGuest} appSettings={appSettings} />
                            </Route>
                        </Switch>
                        :
                        <Switch>
                            <Route path={'/auth'}>
                                <Auth configs={configs} isGuest={isGuest} setIsGuest={setIsGuest} />
                            </Route>
                            <Route path={'/subusers'}>
                                <LayoutSubUsers isGuest={isGuest} appSettings={appSettings} />
                            </Route>
                            <Route path={'/'}>
                                <LayOutHome
                                    isGuest={isGuest}
                                    configs={configs}
                                    network={network}
                                    type={type}
                                    appSettings={appSettings}
                                />
                            </Route>
                        </Switch>
                }

                {appColors ? <CustomStyle appColors={appColors} /> : null}

            </>


            {appColors ? <CustomStyle appColors={appColors} /> : null}

        </> : <Loading />

    )
}

export default App